<input 
    type="date"
    [min]="minDate"
    [max]="maxDate"
    name="dateSelector"
    id="dateSelector"
    class="tw-bg-white tw-border tw-border-border-light-gray tw-cursor-pointer tw-mb-3 tw-min-h-[50px] tw-p-2 tw-rounded-xl"
    (change)="onDateChange($event)"
>